import { observer } from 'mobx-react-lite';
import { ModalOption } from '@client/store/modalStore';
import DocViewer from '@app/haewao/client/view/common/DocViewer';
import { Modal } from '@client/component/modal/Modal';
import { createPlugin } from '@client/component/modal/modalPlugin';

/**
 * 가이드 문서를 표시하는 모달
 */
const GuideModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <DocViewer docKey={option.guide?.docKey || ''} />
            </Modal.BodyScroll>
        </Modal.Dialog>
    );
});

/**
 * 해와오 가이드 모달 플러그인
 */
export const guidePlugin = createPlugin({
    type: 'haewaoGuide' as const,
    component: GuideModal,
    createModalOption: ({ docKey }: { docKey: string }) => ({
        backdrop: true,
        showCloseButton: true,
        guide: {
            docKey,
        },
    }),
});
